import { MenuItemsGroup } from "@/api/types/helpers/types";
import { UserInfoDto } from "@/api/types/main/schemas";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { NavLink } from "react-router-dom";

const SecondaryNavGroup = ({
  secondaryMenuItems,
  user,
  className,
}: {
  secondaryMenuItems: Omit<MenuItemsGroup, "department">[];
  user: UserInfoDto;
  className?: string;
}) => {
  const filteredMainMenuItems = secondaryMenuItems
    .map((group) => ({
      ...group,
      menuItems: group.menuItems.filter(
        (item) => item.role.includes(user.role) || item.role === "all"
      ),
    }))
    .filter((group) => group.menuItems.length > 0);

  return (
    <SidebarGroup className={cn(className)}>
      <SidebarMenu className="group/collapsible">
        {filteredMainMenuItems.map((group) =>
          group.menuItems.map((item) => (
            <SidebarMenuItem key={item.path}>
              <SidebarMenuButton asChild tooltip={item.label}>
                <NavLink to={item.path}>
                  {item.icon && <item.icon />}
                  <span>{item.label}</span>
                </NavLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))
        )}
      </SidebarMenu>
    </SidebarGroup>
  );
};

export default SecondaryNavGroup;
